<template>
  <div class="boughtinfo">
    <global-header></global-header>
    <div class="content-wrapper">
      <my-study-nav :nowLink="'lesson'"></my-study-nav>
      <div class="content-right">
        <div class="classinfo-wrapper" v-if="purchaseclassinfo">
          <img class="info-img" :src="imgprefix+purchaseclassinfo.lessonfaceimg" alt="img" width="180" height="120">
          <div class="classinfo-text-wrapper">
            <h2 class="classinfo-text-title">
              {{decodeURIComponent(purchaseclassinfo.lessonname)}}</h2>
            <p class="classinfo-text-row">
              班级:{{decodeURIComponent(purchaseclassinfo.classmodename)}}-{{decodeURIComponent(purchaseclassinfo.classname)}}<span
              class="split"></span>报名费用:{{decodeURIComponent(purchaseclassinfo.paymoney)}}元
              <!--<span-->
              <!--class="split"></span>开课时间:{{decodeURIComponent(purchaseclassinfo.startdate.substring(0,10))}}-->
              <!--{{purchaseclassinfo.starttime.substring(0,5)}}-{{purchaseclassinfo.endtime.substring(0,5)}}-->
            </p>
            <p class="classinfo-text-row" v-if="purchaseclassinfo.democlass=='1'">
              试听课次:共1课<span class="split"></span><span class="enroll-icon"></span><a class="buy-link"
                                                                                     :href="computeLink(purchaseclassinfo)">正式课报名</a>
            </p>
            <p class="classinfo-text-row" v-if="classHourInfo!=null&& purchaseclassinfo.democlass=='0'">
              预计剩余课次:{{classHourInfo.classnums}}次<span class="split"></span>已上完课时:{{computeTotalHour(classHourInfo.finishedclasshour)}}<span
              class="split"></span>总课时:{{computeTotalHour(classHourInfo.classhour)}}
            </p>
          </div>
        </div>
        <p class="hint-para" v-if="purchaseclassinfo.democlass==0">全优在线课程目录调整：正式课中只有把未开始的课程上完，课程目录才会生成新的一节</p>
        <div class="list-wrapper">
          <div class="catalog-list-wrapper">
            <template v-for="(item,index) in scheduleList" v-if="(index>=(currentPage-1)*10)&&(index<currentPage*10)">
              <div class="catalog-list-item">
                <section class="place">
                  <span class="free-icon" v-if="purchaseclassinfo.democlass===1">试听</span>
                  <template v-else>
                    <span class="catalog-item-title">{{totoalPage-index}}</span>
                    <span class="catalogname">{{decodeURIComponent(item.catalogname)}}</span>
                  </template>
                </section>
                <span class="done" v-if="item.statusflag=='1'"></span>
                <span class="ongoing" v-if="item.statusflag=='2'">正在上课</span>
                <span class="not-start" v-if="item.statusflag=='0'">未开始</span>
                <button class="go-class" @click="gotoLive(item)"
                        v-if="item.statusflag!='1'||isSameDay(returnServerToday,item.planstarttime.substring(0,10))">
                  进入上课
                </button>
                <button class="back-live"
                        v-if="item.statusflag==1&&item.txtfilename!==''&&item.mp3filename!==''"
                        @click="reviewLive(item)">回顾直播
                </button>
                <button class="check-btn" :class="{'show':item.show,'not-show':!item.show}"
                        @click="getCourseWare(item,index)">查看课件
                </button>
                <span class="catalog-item-time">{{item.planstarttime.substring(0, 10)}}</span>
              </div>
              <div class="wareList-wrapper" v-if="item.show">
                <template v-if="!isEmpty(item.coursewarelist)">
                  <div class="ware-item" v-for="(data,index2) in item.coursewarelist">
                    <div class="ware-img-wrapper">
                      <img :src="imgprefix+data.faceimg" alt="课件封面" width="60" height="40">
                    </div>
                    <p class="courseware-name">{{decodeURIComponent(data.coursewarename)}}</p>
                    <section class="courseware-btn-wrapper">
                      <button class="courseware-btn" @click="previewWare(data)">预览</button>
                    </section>
                  </div>
                </template>
                <section class="no-schedule-wrapper" v-else>
                  <img class="empty-img" src="./empty.png" alt="无课件" width="68" height="68">
                  <span class="no-schedule">暂无课件</span>
                </section>
              </div>
            </template>
          </div>
          <template v-if="totoalPage>10">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              :page-size="10"
              :total="totoalPage">
            </el-pagination>
          </template>
        </div>
      </div>
    </div>
    <div class="chantime-mask" v-if="changetimeShow">
      <div class="chantime">
        <p class="img-wrapper">
          <img class='close'
               @click="newShow=false;"
               src="./changetime-hint.png"
               alt="close"
               width="128"
               height="128">
        </p>
        <h2 class="chantime-title">全优在线更新提示！</h2>
        <p class="changetime-para">各位老师注意了！全优在线更新内容：不是当天的课程，以后不可以进入直播间，老师可以选择修改上课时间再进入直播间</p>
        <button class="changetime-btn" @click="changetimeShow=false">我知道了</button>
      </div>
    </div>
    <foot-nav></foot-nav>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import globalHeader from 'components/globalheader/GlobalHeader'
  import MyStudyNav from 'components/mystudynav/MyStudyNav'
  import footNav from 'components/footnav/FootNav'
  import {isSameDay} from 'common/js/calendar.js'

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        purchaseclassinfo: (() => loadLocal('purchaseclassinfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //----课时信息-----//
        classHourInfo: null,
        //-------------以下内容和课程表有关--------------//
        returnServerToday: null,     //服务端返回的今天日期
        scheduleList: [],           //课程表列表
        currentPage: 1,
        totoalPage: 0,
        //-----------以下内容和班级信息有关------------//
        classinfo: null,         //班级信息
        //-------------------以下内容和与预览课件有关----------------------//
        classWareList: [],
        //--------修改时间提示----------//
        changetimeShow: false,

      }
    },
    methods: {
      isSameDay(one, two) {
        return isSameDay(one, two);
      },
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      computeLink(item) {
        return '/study/course/rid/' + item.rid + '/lessonid/' + item.lessonid;
      },
      computeTotalHour(item) {
        let hour = Math.floor(item / 60);
        let minutes = item % 60;
        return `${hour}小时${minutes}分钟`
      },
      loadSchedule(page) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCatalog',
            a: 'QueryNewClassCatalogs',
            isstudent: 1,
            id: this.id,
            classid: this.purchaseclassinfo.classid,
            pageno: page,
            pagesize: 10,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            if (!this.returnServerToday) {
              this.returnServerToday = response.date;
            }
            this.totoalPage = Number(response.recordcount);
            let list = response.list;
            for (let i = 0; i < list.length; i++) {
              list[i].show = false;
              list[i].coursewarelist = null;
              this.scheduleList[(page - 1) * 10 + i] = list[i];
            }
            this.$forceUpdate();
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      handleCurrentChange(val) {
        this.loadSchedule(val);
      },
      gotoLive(item) {
        if (this.isSameDay(this.returnServerToday, item.planstarttime.substring(0, 10))) {
          let id = this.id;
          let classid = item.classid;
          let rid = item.rid;
          let lessonid = item.lessonid;
          let catalogindex = item.catalog_index;
          let catalogid = item.id;
          window.open(`${this.GLOBAL.liveUrl}/live.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
        }else{
          this.changetimeShow = true;
        }
      },
      reviewLive(item) {
        let id = this.id;
        let classid = item.classid;
        let rid = item.rid;
        let lessonid = item.lessonid;
        let catalogindex = item.catalog_index;
        let catalogid = item.id;
        window.open(`${this.GLOBAL.liveUrl}/review.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
      },
      //------------------以下内容和预览课件有关----------------//

      computeUrl(url) {
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      //预览课件和分享课件(预览和分享是同一个功能)
      previewWare(item) {
        window.open(`${this.GLOBAL.playUrl}v/${item.code}`);
      },
      getCourseWare(item, index) {
        if (item.show == false) {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'ClassCourseWare',
              a: 'QueryClassCourseWare',
              id: this.id,
              classcatalogid: item.id,
              pageno: 1,
              pagesize: 100,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 111) {
              this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
            }
            if (response.code === 200) {
              item.coursewarelist = response.list;
//              Vue.set(item, coursewarelist, response.list);
              this.$forceUpdate();
            }
          }).catch((err) => {
            this.$alert('未获取到数据，请重新加载页面', '提示', {
              confirmButtonText: '刷新',
              callback: action => {
                window.location.reload();
              }
            });
          });
          item.show = true;
        } else {
          item.show = false;
        }
        this.$forceUpdate();
      },
      //隐藏收费课的课件
      hideCourseWare(item) {
        item.show = false;
        this.$forceUpdate();
      },
      // 查询班级课时详情
      queryClassHour(item) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassHour',
            a: 'QueryClassHour',
            id: this.id,
            classid: item.classid,
            catalog_index: item.catalog_index,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.classHourInfo = response.list[0];
          }
        }).catch((err) => {

        })
      }
    },
    created() {
      this.loadSchedule(1);
      if (this.purchaseclassinfo.democlass == '0') {
        this.queryClassHour(this.purchaseclassinfo);
      }
    },
    components: {
      globalHeader,
      MyStudyNav,
      footNav
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  body {
    background: #f2f2f2
  }
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .boughtinfo
    margin-top: 134px
    box-sizing border-box
    background: #f2f2f2
    overflow: hidden
    .content-wrapper
      width: 1226px
      min-height: calc(100vh - 345px)
      margin: 0 auto
      padding-bottom: 40px
      font-size: 0
      overflow hidden
      .content-right
        float: right
        width: 966px
        .classinfo-wrapper
          padding: 15px
          height: 120px
          background: #fff
          .info-img
            float: left
            border-radius: 4px
          .classinfo-text-wrapper
            float: left
            margin-left: 20px
            .classinfo-text-title
              margin-bottom: 20px
              font-size: 24px
              color: #333
              font-weight: bold
              height: 31px
              line-height: 31px
            .classinfo-text-row
              margin-bottom: 12px
              font-size: 14px
              color: #a5a5a5
              height: 19px
              line-height: 19px
              .split {
                position: relative
                top: 3px
                display: inline-block
                height: 15px
                width: 1px
                margin: 0 20px
                background: #a5a5a5
              }
              .enroll-icon {
                margin-right: 5px
                vertical-align: top
                display: inline-block
                width: 19px
                height: 19px
                background: url('./enroll.png') no-repeat center / 19px
              }
              .buy-link {
                font-size: 14px
                color: #333333
                padding-right: 18px
                background: url('./right-arrow.png') no-repeat right center / 13px 13px
                &:hover {
                  color: #ff6700
                }
              }
        .hint-para {
          border-top:1px solid #e9e9e9
          padding-left: 15px
          text-indent: 22px
          font-size: 14px
          color: #ff0000
          height: 39px
          line-height: 39px
          background: #fff url('./hint.png') no-repeat left 15px center / 17px
        }
        .list-wrapper
          background: #fff
          .schedule-title
            height: 70px
            line-height: 70px
            font-size: 18px
            color: #333333
          .catalog-list-wrapper
            .catalog-list-item
              height: 80px
              padding-right: 30px
              border-top: 1px solid #e9e9e9
              .place
                float: left
                height: 80px
                .free-icon,.catalog-item-title
                  margin: 25px 0 0 15px
                  float: left
                  width: 50px
                  height: 30px
                  text-align: center
                  line-height: 30px
                  font-size: 16px
                  border-radius: 15px
                  background: #ff6700
                  color: #fff
                .catalog-item-title{
                  width: 30px
                  margin-right:22px
                }
                .catalogname
                  float: left
                  height: 80px
                  line-height: 80px
                  font-size: 16px
                  color: #333

              .not-start, .ongoing
                margin-left:30px
                float: left
                height: 80px
                line-height: 80px
                font-size: 14px
                color: #ff6700
              .done {
                margin: 20px 0 0 30px
                float: left
                width: 52px
                height: 40px
                background: url('./finish.png') no-repeat center / 52px 40px
              }
              .go-class, .back-live, .add-ware-btn {
                float: right
                margin: 24px 0 0 10px
                width: 100px
                height: 32px
                line-height: 32px
                font-size: 16px
                color: #ffffff
                border-radius: 4px
                box-sizing: border-box
              }
              .go-class {
                background #ff6700
              }
              .back-live {
                background #d9a60d
              }
              .add-ware-btn {
                color: #333
                border: 1px solid #e9e9e9
              }
              .check-btn {
                float: right
                margin-top: 24px
                width: 100px
                height: 32px
                line-height: 32px
                font-size: 16px
                color: #333
                text-align: left
                text-indent: 10px
                border-radius: 4px
                border: 1px solid #e9e9e9
                box-sizing: border-box
                &.show {
                  background: url('./up.png') no-repeat right 8px center / 14px 14px
                }
                &.not-show {
                  background: url('./down.png') no-repeat right 8px center / 14px 14px
                }
              }
              .catalog-item-time {
                float: right
                margin-right: 30px
                line-height: 80px
                font-size: 14px
                color: #333
              }
              .mulu-operate-wrapper
                float: right
                margin: 0 30px 0 0
                height: 32px
                .mulu-btn
                  margin-top: 24px
                  float: right
                  width: 100px
                  height: 32px
                  line-height: 32px
                  font-size: 16px
                  color: #fff
                  margin-right: 10px
                  border-radius: 16px
                  box-sizing: border-box
                  &:last-child
                    margin: 0
                .check
                  background: #fff
                  color: #ff6700
                  border: 1px solid #ff6700
                .live
                  background: #ff6700
                .going
                  background: #12d100
                .review
                  background: #087c8d
                .catalog-item-time
                  float: right
                  margin-right: 30px
                  line-height: 80px
                  font-size: 16px
                  color: #333
                  &.pass
                    color: #888888
            .wareList-wrapper
              background: #fff
              .ware-item
                height: 80px
                background: #ffffff
                border-top: 1px solid #f5f5f5
                .ware-img-wrapper
                  float: left
                  width: 84px
                  height: 60px
                  margin: 10px 30px 0 10px
                .courseware-name
                  float: left
                  line-height: 80px
                  font-size: 16px
                  color: #333
                .courseware-btn-wrapper
                  float: right
                  margin: 24px 30px 0 0
                  height: 32px
                  .courseware-btn
                    display: inline-block
                    width: 100px
                    height: 32px
                    line-height: 32px
                    font-size: 16px
                    color: #fff
                    background: #ff6700
                    border-radius: 16px
                    box-sizing: border-box
              .no-schedule-wrapper
                height: 80px
                border-top: 1px solid #f5f5f5
                .empty-img {
                  float: left
                  margin: 6px 14px 0 390px
                }
                .no-schedule {
                  font-size: 16px
                  color: #cccccc
                  line-height: 80px
                }

    .chantime-mask {
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .chantime {
        margin: auto
        height: 416px
        width: 460px
        padding: 30px 36px 45px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .img-wrapper {
          margin-bottom: 25px
          text-align: center
        }
        .chantime-title {
          text-align: center
          font-size: 20px
          color: #333333
          font-weight: bold
          height: 28px
          line-height: 28px
        }
        .changetime-para {
          margin: 15px 0 35px
          font-size: 16px
          color: #666666
          line-height: 24px
        }
        .changetime-btn {
          display: block
          margin: 0 auto
          width: 260px
          height: 40px
          line-height: 40px
          font-size: 16px
          color: #fff
          background: #ff6700
          border-radius: 4px
        }

      }
    }
</style>



// WEBPACK FOOTER //
// src/page/boughtinfo/BoughtInfo.vue